import { useCurrentUser } from '@/store/currentUser';
import { useUserContentLastParticipation } from '@/store/v2/catalog-v2/use-user-last-participation';

type UseCurrentUserLiveEventJourneyParticipantHookOptions = {
  journeyId?: number;
};

type UseCurrentUserLiveEventJourneyParticipantHookResult = {
  isJourneyParticipant: boolean;
  loading: boolean;
};

export const useCurrentUserLiveEventJourneyParticipant = ({
  journeyId,
}: UseCurrentUserLiveEventJourneyParticipantHookOptions): UseCurrentUserLiveEventJourneyParticipantHookResult => {
  const { user } = useCurrentUser();

  const journeyURN = journeyId ? `urn:collegial:self:journey:${journeyId}` : undefined;

  const { participation, loading } = useUserContentLastParticipation({
    userId: user?.id,
    contentURN: journeyURN,
  });

  return {
    isJourneyParticipant: Boolean(participation),
    loading: loading,
  };
};
